import React from 'react'
import styled, { css } from 'styled-components'
import { ListItemButton } from '@mui/material'
import { UIStyles } from '../../theme'
import { rotate } from './buttons'
import themeColors from '@layers-frontend/commons/styles/themeColors'
import { StyledTooltip } from './StyledTooltip'

export const Tooltip = styled(StyledTooltip)`
  width: 100%;
  display: flex !important;
  justify-content: center;
  align-items: center;
`

// White for the main bars (left bar), mint for buttons inside panels and content.
const accents = {
  white: { color: UIStyles.whiteColor, hover: UIStyles.whiteTransparent01, active: UIStyles.lightGrayHoverColor },
  mint: { color: UIStyles.mintColor, hover: UIStyles.mintColorHoverTransparent, active: UIStyles.mintColorTransparent }
}

const listItemSx = accent => ({
  marginLeft: 0,
  padding: '16px',
  position: 'relative',
  cursor: 'pointer',
  justifyContent: 'center',
  color: accent.color,
  ':hover': {
    backgroundColor: accent.hover
  }
})

const Icon = styled.i`
  position: relative;
  font-size: ${props => (props.loading ? '0' : '24px')};
  color: ${({ disabled, accentColor }) => (disabled ? themeColors.whiteColor : accentColor)};
  ${props =>
    props.iconAfter &&
    css`
      /* The "+" badge gets a ring in the bar's navy, so it cuts cleanly into the icon below it. */
      &::after {
        content: '\f067';
        font-size: 10px;
        position: absolute;
        bottom: -10px;
        right: -10px;
        color: ${({ disabled }) => (disabled ? themeColors.lightGreySolid : themeColors.deepblueColor3)};
        border-radius: 50%;
        background: ${({ disabled, accentColor }) => (disabled ? themeColors.whiteColor : accentColor)};
        padding: 0.3rem;
        border: 1px solid;
        box-shadow: 0 0 0 2px ${themeColors.deepblueColor3};
        display: flex;
        justify-content: center;
        flex-direction: row;
      }
    `}

  ${props =>
    props.loading &&
    css`
      &:after {
        content: '';
        display: ${props => (props.loading ? 'inline-block' : 'none')};
        width: 30px;
        height: 30px;
        border-radius: 50%;
        /* The arc turns on a faint track. */
        border: 2px solid ${themeColors.whiteTransparent015};
        border-top-color: ${props => props.accentColor};
        animation: ${rotate} 1.5s ease-in-out infinite;
      }
    `}
`

const StyledListButton = ({
  value,
  disabled,
  label,
  onClick,
  icon,
  isActiveListItem,
  labelDistance,
  iconAfter = false,
  loading = false,
  hidden,
  itemStyle = {},
  testId,
  disableTooltip = false,
  accent = 'white'
}) => {
  if (hidden) return null

  const Wrapper = disableTooltip ? ({ children }) => children : Tooltip
  const accentStyle = accents[accent]

  return (
    <Wrapper disabled={disabled} title={label} placement="right" style={itemStyle}>
      <ListItemButton
        key={value}
        onClick={onClick}
        value={value}
        style={{ fontSize: 25 }}
        sx={[listItemSx(accentStyle), isActiveListItem && { backgroundColor: accentStyle.active }]}
        disabled={disabled}
      >
        <Icon className={`${icon}`} disabled={disabled} iconAfter={iconAfter} loading={loading} accentColor={accentStyle.color} data-testid={testId} />
      </ListItemButton>
    </Wrapper>
  )
}
export default StyledListButton
